import Skeleton from "react-loading-skeleton";

export default function StyleGuideSkeleton() {
    return (
        <div className="sizeguide-skeleton">
            {/* Hero */}
            <div className="hero-skeleton">
                <Skeleton height={471} />
                <div className="hero-skeleton-text">
                    <Skeleton width="70%" height={40} />
                    <Skeleton width="90%" height={20} count={2} />
                </div>
            </div>

            {/* Steps */}
            <Skeleton width="30%" height={28} className="mb-30" />
            <div className="steps-skeleton-grid">
                {[...Array(4)].map((_, i) => (
                    <div key={i} className="step-item-skeleton">
                        <Skeleton width={50} height={50} />
                        <div>
                            <Skeleton width={120} height={20} />
                            <Skeleton width={180} height={16} count={2} />
                        </div>
                    </div>
                ))}
            </div>

            {/* Style blocks */}
            {[...Array(3)].map((_, i) => (
                <div key={i} className="style-block-skeleton">
                    <Skeleton width={600} height={600} />
                    <div>
                        <Skeleton width="60%" height={24} />
                        <Skeleton count={3} />
                        <Skeleton width={120} height={36} />
                    </div>
                </div>
            ))}
        </div>
    );
}
